module.exports = __webpack_public_path__ + "static/media/spinner.9f0bb82a.gif";